// extracted by mini-css-extract-plugin
export var active = "_bd-2";
export var highlight = "_bd-1";
export var highlightLayer = "_bd-0";
export var issuePopover = "_bd-3";
export var statusIcon = "_bd-4";